var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_944_4663",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_944_4663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.83329 16.6663C3.37496 16.6663 2.9826 16.5031 2.65621 16.1768C2.32982 15.8504 2.16663 15.458 2.16663 14.9997V4.99967C2.16663 4.54134 2.32982 4.14898 2.65621 3.82259C2.9826 3.4962 3.37496 3.33301 3.83329 3.33301H7.99996V4.99967H3.83329V14.9997H17.1666V4.99967H13V3.33301H17.1666C17.625 3.33301 18.0173 3.4962 18.3437 3.82259C18.6701 4.14898 18.8333 4.54134 18.8333 4.99967V14.9997C18.8333 15.458 18.6701 15.8504 18.3437 16.1768C18.0173 16.5031 17.625 16.6663 17.1666 16.6663H3.83329ZM10.5 12.833L6.33329 8.66634L7.49996 7.49967L9.66663 9.66634V3.33301H11.3333V9.66634L13.5 7.49967L14.6666 8.66634L10.5 12.833Z",
    fill: "#068EFE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportBlue);
export default __webpack_public_path__ + "static/media/import-blue.d6cc23fd2ec55432a4091d2a7d4208bb.svg";
export { ForwardRef as ReactComponent };